import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
export const LoadingSpinner = ({ text, ...props }) => {
    return (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 2, my: 2 }, children: [_jsx(CircularProgress, { size: 24, ...props }), text && _jsx(Typography, { children: text })] }));
};
//# sourceMappingURL=LoadingSpinner.js.map